import { ApprovalState, ReportType } from '@fdm/api-client';
import { ReportFormPage } from '../../report-form-control.service';

export const INITIATOR_POLICY = {
  [ReportType.AnomalyReport]: {
    [ReportFormPage.GENERAL]: [ApprovalState.Draft],
    [ReportFormPage.EQUIPMENTS]: [ApprovalState.Draft],
    [ReportFormPage.APPROVAL_FLOW]: [ApprovalState.Draft],
    [ReportFormPage.RIPT]: [ApprovalState.PlanConfirmed],
    [ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN]: [
      ApprovalState.Draft,
      ApprovalState.ResolutionPlanCompleted,
    ],
    [ReportFormPage.ACTION_ITEM]: [ApprovalState.Draft, ApprovalState.DraftedForReview, ApprovalState.SubmittedToOpsAdvisor, ApprovalState.PlanApproved],
    [ReportFormPage.NOTES_ATTACHMENTS]: [
      ApprovalState.Draft,
      ApprovalState.DraftedForReview,
      ApprovalState.PlanConfirmed,
      ApprovalState.PlanEndorsed,
      ApprovalState.PlanApproved,
      ApprovalState.RIPTScored,
      ApprovalState.ResolutionPlanCompleted,
      ApprovalState.ValidationAndVerificationCompleted,
    ],
    [ReportFormPage.FINDING_DESCRIPTION]: [ApprovalState.Draft]
  },
  [ReportType.IntegrityDeficiency]: {
    [ReportFormPage.GENERAL]: [ApprovalState.Draft],
    [ReportFormPage.EQUIPMENTS]: [ApprovalState.Draft],
    [ReportFormPage.APPROVAL_FLOW]: [ApprovalState.Draft],
    [ReportFormPage.RIPT]: [ApprovalState.PlanConfirmed],
    [ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN]: [
      ApprovalState.Draft,
      ApprovalState.ResolutionPlanCompleted,
    ],
    [ReportFormPage.ACTION_ITEM]: [ApprovalState.Draft, ApprovalState.DraftedForReview, ApprovalState.SubmittedToOpsAdvisor, ApprovalState.PlanApproved],
    [ReportFormPage.NOTES_ATTACHMENTS]: [
      ApprovalState.Draft,
      ApprovalState.DraftedForReview,
      ApprovalState.SubmittedToOpsAdvisor,
      ApprovalState.PlanConfirmed,
      ApprovalState.PlanEndorsed,
      ApprovalState.PlanApproved,
      ApprovalState.RIPTScored,
      ApprovalState.RiskEvaluationScored,
      ApprovalState.ResolutionPlanCompleted,
      ApprovalState.ValidationAndVerificationCompleted,
    ],
    [ReportFormPage.FINDING_DESCRIPTION]: [ApprovalState.Draft]
  },
  [ReportType.ReliabilityDeficiency]: {
    [ReportFormPage.GENERAL]: [ApprovalState.Draft],
    [ReportFormPage.EQUIPMENTS]: [ApprovalState.Draft],
    [ReportFormPage.APPROVAL_FLOW]: [ApprovalState.Draft],
    [ReportFormPage.RIPT]: [ApprovalState.PlanConfirmed],
    [ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN]: [
      ApprovalState.Draft,
      ApprovalState.ResolutionPlanCompleted,
    ],
    [ReportFormPage.ACTION_ITEM]: [ApprovalState.Draft, ApprovalState.DraftedForReview, ApprovalState.SubmittedToOpsAdvisor, ApprovalState.PlanApproved],
    [ReportFormPage.NOTES_ATTACHMENTS]: [
      ApprovalState.Draft,
      ApprovalState.DraftedForReview,
      ApprovalState.SubmittedToOpsAdvisor,
      ApprovalState.PlanConfirmed,
      ApprovalState.PlanEndorsed,
      ApprovalState.PlanApproved,
      ApprovalState.RIPTScored,
      ApprovalState.RiskEvaluationScored,
      ApprovalState.ResolutionPlanCompleted,
      ApprovalState.ValidationAndVerificationCompleted,
    ],
    [ReportFormPage.FINDING_DESCRIPTION]: [ApprovalState.Draft]
  },
  [ReportType.IntegrityThreat]: {
    [ReportFormPage.GENERAL]: [ApprovalState.Draft],
    [ReportFormPage.EQUIPMENTS]: [ApprovalState.Draft],
    [ReportFormPage.APPROVAL_FLOW]: [ApprovalState.Draft],
    [ReportFormPage.RIPT]: [ApprovalState.PlanConfirmed],
    [ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN]: [
      ApprovalState.Draft,
      ApprovalState.ResolutionPlanCompleted,
    ],
    [ReportFormPage.ACTION_ITEM]: [ApprovalState.Draft, ApprovalState.DraftedForReview, ApprovalState.SubmittedToOpsAdvisor, ApprovalState.PlanApproved],
    [ReportFormPage.NOTES_ATTACHMENTS]: [
      ApprovalState.Draft,
      ApprovalState.DraftedForReview,
      ApprovalState.SubmittedToOpsAdvisor,
      ApprovalState.PlanConfirmed,
      ApprovalState.PlanEndorsed,
      ApprovalState.PlanApproved,
      ApprovalState.RIPTScored,
      ApprovalState.ResolutionPlanCompleted,
      ApprovalState.ValidationAndVerificationCompleted,
    ],
    [ReportFormPage.FINDING_DESCRIPTION]: [ApprovalState.Draft]
  },
  [ReportType.ReliabilityThreat]: {
    [ReportFormPage.GENERAL]: [ApprovalState.Draft],
    [ReportFormPage.EQUIPMENTS]: [ApprovalState.Draft],
    [ReportFormPage.APPROVAL_FLOW]: [ApprovalState.Draft],
    [ReportFormPage.RIPT]: [ApprovalState.PlanConfirmed],
    [ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN]: [
      ApprovalState.Draft,
      ApprovalState.ResolutionPlanCompleted,
    ],
    [ReportFormPage.ACTION_ITEM]: [ApprovalState.Draft, ApprovalState.DraftedForReview, ApprovalState.SubmittedToOpsAdvisor, ApprovalState.PlanApproved],
    [ReportFormPage.NOTES_ATTACHMENTS]: [
      ApprovalState.Draft,
      ApprovalState.DraftedForReview,
      ApprovalState.SubmittedToOpsAdvisor,
      ApprovalState.PlanConfirmed,
      ApprovalState.PlanEndorsed,
      ApprovalState.PlanApproved,
      ApprovalState.RIPTScored,
      ApprovalState.ResolutionPlanCompleted,
      ApprovalState.ValidationAndVerificationCompleted,
    ],
    [ReportFormPage.FINDING_DESCRIPTION]: [ApprovalState.Draft]
  },
  [ReportType.TaskDeferral]: {
    [ReportFormPage.GENERAL]: [ApprovalState.Draft],
    [ReportFormPage.EQUIPMENTS]: [ApprovalState.Draft],
    [ReportFormPage.APPROVAL_FLOW]: [ApprovalState.Draft],
    [ReportFormPage.RISK_EVALUATION]: [
      ApprovalState.Draft,
      ApprovalState.RiskEvaluationScored,
    ],
    [ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN]: [
      ApprovalState.Draft,
      ApprovalState.ResolutionPlanCompleted,
    ],
    [ReportFormPage.ACTION_ITEM]: [ApprovalState.Draft, ApprovalState.DraftedForReview, ApprovalState.SubmittedToOpsAdvisor, ApprovalState.PlanApproved],
    [ReportFormPage.NOTES_ATTACHMENTS]: [
      ApprovalState.Draft,
      ApprovalState.DraftedForReview,
      ApprovalState.SubmittedToOpsAdvisor,
      ApprovalState.PlanConfirmed,
      ApprovalState.PlanEndorsed,
      ApprovalState.PlanApproved,
      ApprovalState.RiskEvaluationScored,
      ApprovalState.ResolutionPlanCompleted,
      ApprovalState.ValidationAndVerificationCompleted,
    ],
    [ReportFormPage.FINDING_DESCRIPTION]: [ApprovalState.Draft]
  },
};
